<template>
  <v-simple-table
    class="rounded-card overflow-hidden"
    fixed-header
  >
    <template v-slot:default>
      <thead>
      <tr>
        <th>Notificação</th>
        <th class="text-center">Whatsapp</th>
        <th class="text-center">E-mail</th>
      </tr>
      </thead>
      <tbody>
      <tr style="height: 55px"
          class="transparent-hover"
          v-for="(configuracao) in notificacoes"
          :key="configuracao.id">
        <td>
          <div class="d-flex align-center">
            <px-tipo-notificacao :tipo-notificacao="configuracao.tipoNotificacao"
                                 :is-notificacao-comprador="isNotificacaoComprador"/>
          </div>
        </td>
        <td>
          <div class="d-flex justify-center">
            <px-switch-tooltip v-model="configuracao.whatsapp.enviaNotificacao"
                               :disabled="disabled(configuracao.whatsapp)"
                               :tooltip="tooltipWhatsapp(configuracao.whatsapp.enviaNotificacao)"
                               @change="saveNotification(configuracao, whatsappKey)"/>
          </div>
        </td>
        <td>
          <div class="d-flex justify-center">
            <px-switch-tooltip v-model="configuracao.email.enviaNotificacao"
                               :disabled="disabled(configuracao.email)"
                               :tooltip="tooltipEmail(configuracao.email.enviaNotificacao)"
                               @change="saveNotification(configuracao, emailKey)"/>
          </div>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { TipoEnvioNotificacao } from 'px-business-components';
import NotificacaoService from '../service/config-notificacao-service';

export default {
  props: {
    notificacoes: {
      type: Array,
      required: true,
    },
    isNotificacaoComprador: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      entityType: this.isNotificacaoComprador ? 'comprador' : 'user',
      whatsappKey: TipoEnvioNotificacao.keys.WHATSAPP.key,
      emailKey: TipoEnvioNotificacao.keys.EMAIL.key,
    };
  },
  computed: {
    tooltipWhatsapp() {
      return enabled => (enabled ? 'O envio desta notificação via whatsapp está ativo' : 'O envio desta notificação via whatsapp está desativado');
    },
    tooltipEmail() {
      return enabled => (enabled ? 'O envio desta notificação via e-mail está ativo' : 'O envio desta notificação via e-mail está desativado');
    },
    disabled() {
      return notificacao => this.loading || notificacao.desativaEdicaoNotificacao;
    },
  },
  methods: {
    buildPayload(notificacao, tipo) {
      const notificacaoPorTipo = tipo === this.whatsappKey
        ? notificacao.whatsapp : notificacao.email;

      const tipoEnvio = tipo === this.whatsappKey ? this.whatsappKey : this.emailKey;
      return {
        id: notificacaoPorTipo.id,
        [this.entityType]: {
          id: notificacao[this.entityType].id,
        },
        tipoNotificacao: notificacao.tipoNotificacao,
        tipoEnvio,
        enabled: notificacaoPorTipo.enviaNotificacao,
      };
    },
    saveUserNotificacao(notificacao, tipo) {
      this.loading = true;
      NotificacaoService.saveUserNotificacao(this.buildPayload(notificacao, tipo))
        .then(() => {
          this.$emit('update');
          this.$toast('Notificação atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveCompradorNotificacao(notificacao, tipo) {
      this.loading = true;
      NotificacaoService.saveCompradorNotificacao(this.buildPayload(notificacao, tipo))
        .then(() => {
          this.$emit('update');
          this.$toast('Notificação atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveNotification(notificacao, tipo) {
      if (this.isNotificacaoComprador) {
        this.saveCompradorNotificacao(notificacao, tipo);
        return;
      }
      this.saveUserNotificacao(notificacao, tipo);
    },
  },
};
</script>
